// **  Initial State
const initialState = {
    allData: [],
    selected: null
}

const tagReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_TAGS':
            return { ...state, allData: action.data }
        case 'ADD_TAGS':
            return { ...state, allData:[...state.allData.concat(action.data)]  }
        case 'SELECTED_TAG':
            return { ...state, selected: action.data }
        case 'UPDATE_TGA':
            return {
                ...state,
                allData: [
                    ...state.allData.filter(tag => tag.id !== action.data.id),
                    action.data
                ]
            }
        case 'DELETE_TAG':
            return {
                ...state,
                allData: state.allData.filter(tag => {return tag.id !== action.data.deleteitems} )
            }
        default:
            return state
    }
}

export default tagReducer
